// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3UEr7","log":"ModalInventoryLogs_log__1bHiM","date":"ModalInventoryLogs_date__1a_nt","userName":"ModalInventoryLogs_userName__2V4h7"};